export default "__VITE_ASSET__DnAmbOXT__"